import { createTheme } from "@mui/material/styles";

export const finnTheme = createTheme({
  palette: {
    primary: { main: "#0D2B55" },
    background: { default: "#F7FBFB", paper: "#FFFFFF" },
    text: { primary: "#102A43", secondary: "#52667A" },
  },
  typography: {
    fontFamily: '"Maison Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: {
      fontSize: "clamp(1.75rem, 5vw, 2.15rem)",
      fontWeight: 400,
      lineHeight: 1.16,
      letterSpacing: "-0.035em",
    },
    h2: {
      fontSize: "1.3rem",
      fontWeight: 500,
      lineHeight: 1.3,
      letterSpacing: "-0.015em",
    },
    body1: { fontSize: "1rem", lineHeight: 1.6 },
    body2: { fontSize: "0.9rem", lineHeight: 1.55 },
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: { borderRadius: 14 },
});

// Retained for callers that imported the old name.
export const joinTheme = finnTheme;

export const pageStyles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#F7FBFB",
    backgroundImage: [
      "radial-gradient(at 18% 16%, rgba(150, 196, 255, 0.22) 0, transparent 50%)",
      "radial-gradient(at 84% 44%, rgba(255, 178, 199, 0.19) 0, transparent 48%)",
      "radial-gradient(at 70% 94%, rgba(199, 179, 255, 0.2) 0, transparent 50%)",
      "radial-gradient(at 8% 86%, rgba(150, 221, 235, 0.14) 0, transparent 46%)",
    ].join(", "),
    backgroundAttachment: "fixed",
    display: "flex",
    flexDirection: "column",
  },
  centerWrapper: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    py: { xs: 4, sm: 6 },
  },
  logo: {
    display: "block",
    width: "92px",
    height: "auto",
    margin: "0 auto",
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    boxSizing: "border-box",
    backgroundColor: "rgba(255, 255, 255, 0.94)",
    border: "1px solid rgba(13, 43, 85, 0.08)",
    borderRadius: { xs: "22px", sm: "28px" },
    px: { xs: 2.75, sm: 5 },
    py: { xs: 3.5, sm: 5 },
    boxShadow: "0 24px 70px rgba(32, 68, 105, 0.12)",
    backdropFilter: "blur(12px)",
  },
  wideCard: { maxWidth: "780px" },
  title: { color: "#102A43", textAlign: "center", mb: 1.5 },
  subtitle: { color: "#52667A", textAlign: "center", mb: 3.5 },
  field: {
    mb: 2.5,
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px",
      backgroundColor: "#FFFFFF",
      "& fieldset": { borderColor: "#D8E2EA" },
      "&:hover fieldset": { borderColor: "#9DB0C1" },
      "&.Mui-focused fieldset": { borderColor: "#3856DD" },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#3856DD" },
    "& .MuiOutlinedInput-input": { padding: "15px 14px" },
  },
  primaryButton: {
    minHeight: "50px",
    borderRadius: "14px",
    backgroundColor: "#0D2B55",
    color: "#FFFFFF",
    fontSize: "1rem",
    boxShadow: "0 8px 20px rgba(13, 43, 85, 0.14)",
    transition: "transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
    "&:hover": {
      backgroundColor: "#163B6B",
      boxShadow: "0 10px 24px rgba(13, 43, 85, 0.2)",
      transform: "translateY(-1px)",
    },
    "&:active": { transform: "translateY(0)" },
    "&.Mui-disabled": { backgroundColor: "#CAD4DE", color: "#FFFFFF" },
  },
  option: {
    border: "1px solid #DDE6ED",
    borderRadius: "14px",
    px: 1.5,
    py: 1.25,
    mb: 1.5,
    backgroundColor: "rgba(255, 255, 255, 0.78)",
  },
};
